import { axiosPrivate } from "../../api/axios";
export const updateOrderDeliveryPickupLocation_V2 = (newLocation) => {
    return axiosPrivate.post("/Account/OrderInfo/OrderAddressLocation", newLocation);
};
export const updateOrderDeliveryPickupLocationWithCharge_V2 = (newLocation) => {
    return axiosPrivate.post("/Account/OrderInfo/OrderAddressLocationWithCharge", newLocation);
};
